import {
    UBICACION,
    PAIS,
    CONFIG,
    LOCATIONS,
    STATES,
    MUNICIPALITIES,
    CITIES
} from '@/config/data/parameters';
import {
    db
} from '@/firebase';
import {
    getDocs,
    collection,
    where,
    query,
} from "firebase/firestore/lite";

async function getCountries(){
    try {
        let paises = await getDocs(collection(db, CONFIG, UBICACION, PAIS));
        let result: Array<any> = [];
        paises.forEach(doc => {
            result.push(doc.data())
        });
        return result;
    } catch (error) {
        console.log("Error: ",error);
        return []
    }
}

async function getStates(country_id: string){
    try {
        let estados = await getDocs(query(collection(db, CONFIG, LOCATIONS, STATES), where("country_id", "==", country_id)));
        let result: Array<any> = [];
        estados.forEach(doc => {
            result.push(doc.data())
        });
        return result;
    } catch (error) {
        console.log("Error: ",error);
        return []
    }
}

async function getMunicipalities(state_id: string){
    try {
        let municipios = await getDocs(query(collection(db, CONFIG, LOCATIONS, MUNICIPALITIES), where("state_id", "==", state_id)));
        let result: Array<any> = [];
        municipios.forEach(doc => {
            result.push(doc.data())
        });
        return result;
    } catch (error) {
        console.log("Error: ",error);
        return []
    }
}

async function getCities(municipality_id: string) {
    try {
        let ciudades = await getDocs(query(collection(db, CONFIG, LOCATIONS, CITIES), where("municipality_id", "==", municipality_id)));
        let result: Array<any> = [];
        ciudades.forEach(doc => {
            result.push(doc.data())
        });
        return result;
    } catch (error) {
        console.log("Error: ",error);
        return []
    }
}


export {
    getCities,
    getStates,
    getCountries,
    getMunicipalities
} 